import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useMemo } from "react";
import Stats from "../../Stats";
import useVotersStats from "./useVotersStats";
import useTestingStats from "./useTestingStats";
import useTallyStats from "./useTallyStats";
import usePollsStats from "./usePollsStats";
export var calcTotalApplications = function (approved, disapproved) {
    return typeof approved === "string" || typeof disapproved === "string" ? 0 : disapproved + approved;
};
export var calcPrecentage = function (part, total) {
    return total === 0 || typeof total === "string" || typeof part === "string"
        ? "0"
        : ((part / total) * 100.0).toFixed(2);
};
var ElectionEventStats = function (props) {
    var eligibleVotersCount = props.eligibleVotersCount, enrolledVotersCount = props.enrolledVotersCount, electionsCount = props.electionsCount, startedVoteCount = props.startedVoteCount, notStartedVotesCount = props.notStartedVotesCount, openVotesCount = props.openVotesCount, notOpenVotesCount = props.notOpenVotesCount, closedVotesCount = props.closedVotesCount, notClosedVotesCount = props.notClosedVotesCount, startCountingVotesCount = props.startCountingVotesCount, notStartCountingVotesCount = props.notStartCountingVotesCount, initializeCount = props.initializeCount, notInitializeCount = props.notInitializeCount, genereatedTallyCount = props.genereatedTallyCount, notGenereatedTallyCount = props.notGenereatedTallyCount, approvalStats = props.approvalStats, authenticationStats = props.authenticationStats, votingStats = props.votingStats, transmissionStats = props.transmissionStats;
    var votersSection = useVotersStats({
        eligibleVotersCount: eligibleVotersCount,
        enrolledVotersCount: enrolledVotersCount,
        approvalStats: approvalStats,
        authenticationStats: authenticationStats,
    }).votersSection;
    var pollsSection = usePollsStats({
        eligibleVotersCount: eligibleVotersCount,
        enrolledVotersCount: enrolledVotersCount,
        electionsCount: electionsCount,
        startedVoteCount: startedVoteCount,
        notStartedVotesCount: notStartedVotesCount,
        openVotesCount: openVotesCount,
        notOpenVotesCount: notOpenVotesCount,
        closedVotesCount: closedVotesCount,
        notClosedVotesCount: notClosedVotesCount,
        initializeCount: initializeCount,
        notInitializeCount: notInitializeCount,
        votingStats: votingStats,
    }).pollsSection;
    var tallySection = useTallyStats({
        electionsCount: electionsCount,
        startCountingVotesCount: startCountingVotesCount,
        notStartCountingVotesCount: notStartCountingVotesCount,
        genereatedTallyCount: genereatedTallyCount,
        notGenereatedTallyCount: notGenereatedTallyCount,
        transmissionStats: transmissionStats,
    }).tallySection;
    var testSection = useTestingStats({
        enrolledVotersCount: enrolledVotersCount,
        votingStats: votingStats,
    }).testSection;
    var statsSections = useMemo(function () { return [votersSection, pollsSection, tallySection, testSection]; }, [votersSection, pollsSection, tallySection, testSection]);
    return _jsx(Stats, { statsSections: statsSections });
};
export default ElectionEventStats;
